"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18NService = void 0;
class I18NService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns available models
     * @returns I18nModelsResponse
     * @throws ApiError
     */
    getModels() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/i18n/models',
        });
    }
    /**
     * Returns available strings for a model
     * @param model
     * @param q
     * @param page
     * @param count
     * @returns I18nStringsResponse
     * @throws ApiError
     */
    getStrings(model, q, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/i18n/strings',
            query: {
                'model': model,
                'q': q,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Upserts translated strings
     * @param requestBody
     * @returns I18nStringsResponse
     * @throws ApiError
     */
    updateStrings(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/i18n/strings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.I18NService = I18NService;
